module.exports = "/assets/data/08527348e463ea24fc7edf4da426b6b1-B77.data.json";